module.exports = __webpack_public_path__ + "img/218-1461c1.png";